export default [
    {
        path: '/updater', component: () => import('./Updater.vue'), name: 'software.updater', children: []
    }
]
